import { ChatBubbleLeftIcon } from "@heroicons/react/24/outline";
import { Conversation, ConversationItemLoading } from "../conversation_item";

import { useParams } from "react-router-dom";
import { useEffect, useRef } from "react";

export function Conversations(props) {
  const {
    conversations,
    updateSelectedConversation,
    showLoadMoreConversation,
    loadMoreConversations,
    loading,
    assistants,
    setShowDetails,
    setScrollToView,
    conversationsContainerRef,
    isMoreLoading,
  } = props;

  const params = useParams();
  const targetRef = useRef(null);

  useEffect(() => {
    let observer;
    if (conversationsContainerRef.current && targetRef.current) {
      const cb = (entries) => {
        if (entries.length > 0 && entries[0].isIntersecting) {
          loadMoreConversations();
        }
      };

      observer = new IntersectionObserver(
        cb,
        conversationsContainerRef.current
      );

      observer.observe(targetRef.current);
    }

    return () => {
      if (targetRef.current && observer) {
        observer.unobserve(targetRef.current);
      }
    };
  }, [conversationsContainerRef, loadMoreConversations]);

  function isConversationSelected(conversationId) {
    return conversationId === params?.conversationId;
  }

  if (loading) {
    return (
      <>
        {[...Array(20).keys()].map((elem, idx) => (
          <ConversationItemLoading key={idx} />
        ))}
      </>
    );
  }

  return (
    <>
      {conversations.length > 0 ? (
        <div>
          {conversations.map((item, index) => {
            const { sourceOfConversation } = item;

            return Conversation[sourceOfConversation]({
              item,
              isSelected: isConversationSelected(item._id),
              assistantName: assistants[item?.assistant] || "",
              updateSelectedConversation: () =>
                updateSelectedConversation(item),
              setShowDetails,
              setScrollToView,
            });
          })}
          {isMoreLoading &&
            [...Array(1).keys()].map((elem, idx) => (
              <ConversationItemLoading key={idx} />
            ))}
        </div>
      ) : (
        <div className="flex flex-col h-full items-center justify-center my-auto mx-auto">
          <ChatBubbleLeftIcon className="size-12" />
          <p>No threads</p>
        </div>
      )}
      {showLoadMoreConversation && !isMoreLoading && (
        <div
          ref={targetRef}
          className="flex m-4 justify-center cursor-pointer"
          onClick={loadMoreConversations}
        >
          <p className="text-blue-600">Load more conversations</p>
        </div>
      )}
    </>
  );
}
